<template>
    <div class="table_container">
        <common-layout>
            <div slot="header">
                <h3>创客创业管理</h3>
            </div>
            <div slot="container">
                <!-- <div class="handle-box">
                    <el-input style="width:30%;margin:0 10px" placeholder="视频关键词" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-select>
                        <el-option value label="全部"></el-option>
                        <el-option value="1" label="学习课程"></el-option>
                        <el-option value="2" label="点播课程"></el-option>
                    </el-select>
                </div> -->
                <div id="table">
                    <el-table ref="multipleTable" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }" :data="tableData" style="width: 100%" type="index" >
                        <el-table-column type="index" width="100" label="序号" align="center"></el-table-column>
                        <el-table-column prop="title" label="名称" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="添加日期" align="center"></el-table-column>
                        <el-table-column prop="creatorName" label="操作员" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <div class="grid-content bg-purple-light">
                        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper"
                            :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
                    </div>
                </div>
            </div>
        </common-layout>
        <el-dialog
            title="修改创客创业管理"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            width="50%"
            >
            <el-form :model="form" ref="form">
                <el-form-item
                    label="名称"
                    :label-width="formLabelWidth"
                >
                    <el-input
                        v-model="form.title"
                        autocomplete="off"
                        placeholder="请输入名称"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="双创平台运行情况"
                    :label-width="formLabelWidth"
                >
                    <el-input
                    type="textarea"
                    v-model="form.platformOperationStatus"
                    :rows="2"
                    placeholder="请输入双创平台运行情况"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="人员分配"
                    :label-width="formLabelWidth"
                >
                    <el-input
                        v-model="form.staffing"
                        autocomplete="off"
                        placeholder="请输入人员分配"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button type="warning" @click="dialogFormVisible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonLayout from "../../../components/common-layout.vue";
export default {
    components: {
        CommonLayout,
    },
    data() {
        return {
            tableData: [], //列表数据
            total: 10, //总页数
            current_page: 1, //当前页
            per_page: 20, //每页条数
            dialogFormVisible: false,
            form: {},
            formLabelWidth: "150px"
        };
    },
    created() {
        this.getData();
    },
    computed: {
    },
    methods: {
        onSubmit() {
            let params = {
                platformOperationStatus: this.form.platformOperationStatus,
                staffing: this.form.staffing,
                title: this.form.title,
                isShow: 1,
                id: this.form.id
            }
            this.http.put('apij2/admin-api/voucher/large-screen-maker-entrepreneurship-management/update', params).then((response) => {
                if (response.code == 0) {
                    this.$message.success('修改成功');
                    this.getData()
                    this.dialogFormVisible = false;
                }
            });
        },
        handleEdit(item) {
            this.form = {}

            this.$nextTick(() => {
                this.form = {...item};
                this.dialogFormVisible = true;
            });
        },
        //获取列表数据
        getData() {
            let params = {
                page: this.current_page,
                pageSize: this.per_page,
            }
            this.http.post('apij2/admin-api/voucher/large-screen-maker-entrepreneurship-management/page', params).then((response) => {
                this.tableData = response.data.data;
                this.total = response.data.total; //总页数
                this.per_page = response.data.per_page;
                this.current_page = response.data.current_page;
            });
        },
        //选择页码
        handleCurrentChange(e) {
            this.current_page = e;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
* {
    word-break: normal;
}

.table_container {
    height: 100%;
    text-align: left;

    .handle-box {
        .handle-input {
            /deep/.el-input__suffix {
                margin-right: 10px;
            }
        }
    }

    #table {
        margin-top: 20px;
        border: 1px solid #eef1f6;

        /deep/ th {
            // background-color: #eef1f6 !important;
            // color: #000;
        }

        /deep/ td {}

        /deep/ .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                max-width: 100px;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 10px;
    }

    /deep/ .el-dialog__header {
        text-align: center !important;
    }
}

.mess {
    color: red;
    margin-left: 20px;
}
/deep/ .el-dialogFormVisible__header{
		border-bottom: 1px solid #ccc;
		font-size: 20px;
		font-weight: 500;
		padding-bottom: 20px;
		margin-bottom: 10px;
	}
    /deep/ .el-dialogFormVisible__body{
        padding: 20px;
    }
</style>
